export enum ReleaseCodeType
{
    none="none",
    prescription="prescription",
    subscription="subscription",
    both="both"
}